import { showApiError } from "@components/ds/showApiError";
import { getErrorMessageKey } from "./errors";

/**
 * Toasts the Receiving string for an API error (see @components/ds/showApiError)
 * and returns its code. With no error — the empty response a 404 resolves
 * to — it shows the generic string.
 */
export function showReceivingError(error) {
  return showApiError(error, getErrorMessageKey);
}
